import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class CompaniesDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      companies: props.companiesAll || [],
      defaultValue: props.defaultValue || '',
      url: props.url || "/api/v1/portal/companies"
    };
  }

  componentDidMount() {
    this.getCompanies();
  }

  getCompanies() {
    return fetch(this.state.url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token,
        "Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((response) => {
        this.setState({
          companies: response,
          isLoading: false
        })
      });
    });
  }

  handleChange(event) {
    this.setState({defaultValue: event.target.value})
  }

  render() {
    let CompanyDropDownItems = [];
    this.state.companies.forEach(function(i) {
      CompanyDropDownItems.push(<CompanyDropDownItem key={'company'+i.id} data={i} />);
    });
    return(
      <div className="companies-dropdown">
        <select className="form-control form-control-lg" id="company_id" name="company_id" required onChange={this.handleChange.bind(this)} value={this.state.defaultValue}>
          <option value="" disabled> -- select a Company -- </option>
          {CompanyDropDownItems}
        </select>
      </div>
    )
  }
}

class CompanyDropDownItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      company: props.data
    };
  }
  render() {
    return (
      <option value={this.props.data.id}> {this.props.data.name}</option>
    )
  }
}
